import styled from "styled-components";
import CompactTable, {
  leftColumnPrimaryStyle,
  rightColumnPrimaryStyle,
} from "../../components/organisms/CompactTable";
import {
  locationDetailsParams,
  offsetReportOutputParams as params,
} from "../../lib/gpConfig";
import { Label, UnitSpan, Value } from "../../components/atoms/Text";

const Container = styled.div`
  padding-inline: 12px;
  margin-bottom: 8px;
  font-size: 14px;
`;

const DetailsValue = styled(Value)`
  text-transform: capitalize;
`;

const DetailsValueBlock = styled(DetailsValue)`
  display: block;
`;

const leftPrimaryStyle = { width: "75%", ...leftColumnPrimaryStyle };
const rightPrimaryStyle = { width: "25%", ...rightColumnPrimaryStyle };

const primaryRowStyles = [leftPrimaryStyle, rightPrimaryStyle];

interface IProps {
  locationResults: any;
  offsetResults: any;
}

function HabitatGainDetails({ locationResults, offsetResults }: IProps) {
  const getRowData = (param: string) => {
    const { index, label, unit } = (params as any)[param];
    const fullLabel = (
      <span key={index}>
        {label}
        {unit && <UnitSpan>({unit})</UnitSpan>}
      </span>
    );
    let value = offsetResults[index].value;
    return [fullLabel, value];
  };

  const lgas = locationResults[
    locationDetailsParams.localGovernmentAreas.index
  ].value
    .map((x: string) => x.toLowerCase() + " LGA")
    .join(", ");
  const cmas = locationResults[
    locationDetailsParams.catchmentManagementAuthorities.index
  ].value
    .map((x: string) => x.toLowerCase() + " CMA")
    .join(", ");

  const rows: any = [
    {
      rowData: getRowData("habitatGain"),
      rowStyles: primaryRowStyles,
    },
    {
      rowData: getRowData("treesLargeCount"),
      rowStyles: primaryRowStyles,
    },
    {
      rowData: getRowData("strategicBiodiversityScore"),
      rowStyles: primaryRowStyles,
    },
  ];

  return (
    <Container>
      <div>
        <Label>Vicinity</Label>
        <DetailsValueBlock>{lgas}</DetailsValueBlock>
        <DetailsValueBlock
          style={{ fontStyle: "italic", textTransform: "lowercase" }}
        >
          or
        </DetailsValueBlock>
        <DetailsValueBlock>{cmas}</DetailsValueBlock>
      </div>
      <CompactTable
        rows={rows}
        getRowKey={(row: any) => row[0].key}
      ></CompactTable>
    </Container>
  );
}

export default HabitatGainDetails;
